import { useMutation } from "@tanstack/react-query";
import apiClient from "../ApiClient";

const deleteComment = async (commentId: number): Promise<any> => {
  const res = await apiClient.delete(`comments/${commentId}`);
  return res.data;
};

export const useDeleteComment = () => {
  // const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ commentId }: { commentId: number }) => 
      deleteComment(commentId),
    
    onMutate: async ({ commentId }) => {
      // Will store previous data and optimistically remove the comment
    },
    
    onError: (err, variables, context?: any) => {
      // Rollback to previous data on error
      // if (context?.previousData) {
      //   queryClient.setQueryData(FeedsQueryKeys.all, context.previousData);
      // }
    },
  });
};